import useDispatchedModeMapMarkers from './useDispatchedModeMapMarkers';

export default useDispatchedModeMapMarkers;
